<template>
    <div id="EffectiveCPIRateList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Effective CPI Rate List</div>
                    <router-link v-if="canAddEffectiveCpi" class="btn btn-primary pull-right" v-bind:to="{name: 'EffectiveCPIRateCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content effective-cpirate-list">
                        <data-table-filter-config :moduleName="'cpiRateList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'cpiRateList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listEffectiveCPIRateTable"
                                    mode="remote"
                                    title="Effective CPI Rate"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: effectiveCPIRate_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Effective CPI Rate" v-if="canUpdateEffectiveCpi" class="fp-edit" v-bind:to="{name: 'EffectiveCPIRateEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="effectiveCPIRate_value" id="deleteEffectiveCPIRateBtn" v-on:click.prevent="effectiveCPIRateDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "EffectiveCPIRateList",
        metaInfo() {
            return {title: "Effective CPI Rate List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:false,
                },
                {
                    label: 'CPI Code',
                    field: 'cpi_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "CPI Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Base Value',
                    field: 'base_value',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Base Value", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Effective Date',
                    field: 'effective_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                /* {
                    label: 'Creation Date',
                    field: 'created_at',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }, */
            ],
            rows: [],
            totalRecords: 0,
            effectiveCPIRate_value: false,
            loading:false,
            canUpdateEffectiveCpi:false,
            canAddEffectiveCpi:false
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_effective_cpi_rate') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_effective_cpi_rate') {
                            self.effectiveCPIRate_value = true;
                        }
                        if (permissions[i].name == 'add_effective_cpi_rate') {
                            self.canAddEffectiveCpi = true;
                            self.canUpdateEffectiveCpi = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listEffectiveCPIRateTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/effectivecpirate/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'effective-cpi-list')
                    }
                });
            },

            effectiveCPIRateDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Effective CPI Rate?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listEffectiveCPIRateTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listEffectiveCPIRateTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteEffectiveCPIRateBtn").val("Deleting ...");
                      $.ajax({
                          url: process.env.ROOT_API + "/effectivecpirate/delete",
                          type: "POST",
                          data: 'id=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                              $(".alert-success").removeClass("show");
                                  $(".alert-success").addClass("hide");
                              }, 10000);
                              setTimeout(function () {
                                  $("#deleteEffectiveCPIRateBtn").val("Delete");
                              }, 10000);
                              self.rows = data.content.row;
                              if (data.code == '200') {
                                  self.rows = data.content.row;
                                  self.totalRecords = data.content.totalRecords;
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              self.generateStatusCodeMessage(jqXHR,true,'effective-cpi-delete')
                          }
                      });
                    } else {
                      console.log("no");
                    }
                });

              //   if (confirm('Are you sure that you want to delete this Effective CPI Rate? ')) {
              //  }
            }
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/EffectiveCPIRateList.vue